export const copyTextToClipboard = async (text: string) => {
  if ('clipboard' in navigator) {
    try {
      return await navigator.clipboard.writeText(text);
    } catch (error) {
      console.log(error);
    }
  }
  return '';
};
